import React from "react";
import { View, StyleSheet, Modal } from "react-native";
import CustomText from "../../../components/common/general/CustomText/CustomText";
import CustomSpacing from "../../../components/common/layout/CustomSpacing/CustomSpacing";
import CustomButton from "../../../components/common/general/CustomButton/CustomButton";
import { useFocusTrap } from "../../../hooks/useFocusTrap";

interface AssessmentBlockedModalProps {
  visible: boolean;
  onConfirm: () => void;
  title?: string;
  description?: string;
}

const AssessmentBlockedModal: React.FC<AssessmentBlockedModalProps> = ({
  visible,
  onConfirm,
  title = "Assessment Completed",
  description = "Retake is not allowed. This assessment is already completed.",
}) => {
  const { trapRef: modalRef } = useFocusTrap({ visible, onEscape: onConfirm });

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={visible}
      accessibilityViewIsModal={true}
      onRequestClose={onConfirm}>
      <View style={styles.centeredView}>
        <View
          ref={modalRef}
          role="dialog"
          aria-modal={true}
          aria-label="Assessment Completed"
          accessibilityLabel="Assessment Completed"
          style={styles.modalView}>
          <CustomText
            role="heading"
            aria-level={1}
            accessibilityRole="header"
            text={title}
            size="xxl"
            weight="ultraBold"
            style={{ color: "#101828", textAlign: "center" }}
          />
          <CustomSpacing type="vertical" size="l" />
          <CustomText text={description} size="l" weight="normal" style={{ color: "#344054", textAlign: "center" }} />
          <CustomSpacing type="vertical" size="l" />
          <CustomSpacing type="vertical" size="xxl" />
          <View style={styles.buttonBox}>
            <CustomButton
              aria-label="Go to the course page"
              accessibilityLabel="Go to the course page"
              accessibilityRole="button"
              text="Go to the course page"
              onPress={onConfirm}
              styleType="primary"
              style={styles.primaryButton}
              textStyle={{ fontWeight: "700", fontSize: 18, fontFamily: "Inter" }}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  modalView: {
    borderRadius: 20,
    padding: 40,
    height: "auto",
    maxWidth: 688,
    width: "auto",
    backgroundColor: "white",
  },
  buttonBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: 12,
  },
  primaryButton: {
    backgroundColor: "#3E68FE",
    borderRadius: 8,
    padding: 16,
  },
});

export default AssessmentBlockedModal;
